import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'bootstrap/dist/css/bootstrap.css';
import { isChunkLoadError } from './utils/lazyRetry';

// Global safety net: if any code-split chunk fails to load (typically because a
// new deploy replaced the old chunk hashes), reload once to fetch the fresh
// bundle instead of showing the "ChunkLoadError / Loading chunk failed" screen.
const GLOBAL_CHUNK_KEY = 'lazy-chunk-refreshed';
const handleChunkFailure = (error) => {
    if (!isChunkLoadError(error)) return;
    let alreadyRefreshed = false;
    try {
        alreadyRefreshed = window.sessionStorage.getItem(GLOBAL_CHUNK_KEY) === 'true';
    } catch (e) { /* ignore storage errors */ }
    if (!alreadyRefreshed) {
        try { window.sessionStorage.setItem(GLOBAL_CHUNK_KEY, 'true'); } catch (e) { /* ignore */ }
        window.location.reload();
    }
};
window.addEventListener('error', (event) => handleChunkFailure(event?.error || event));
window.addEventListener('unhandledrejection', (event) => handleChunkFailure(event?.reason));

window.formatTimeDuration = (duration) => {
    const [hours, minutes] = duration.split(':').map(Number);

    if (hours === 0) {
        return `${minutes} min${minutes > 1 ? 's' : ''}`;
    } else if (hours === 1 && minutes === 0) {
        return '1 hr';
    } else {
        return `${hours} hr${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : ''}`.trim();
    }
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js');
    });
}

